import React from 'react';

const Spinner = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32',
  };

  return (
    <div className="flex justify-center items-center p-4">
      <div className={`relative ${sizeClasses[size] || sizeClasses.md}`}>
        {/* Logo central pulsante */}
        <img
          src="/images/favico/agora.png"
          alt="Cargando..."
          className="w-full h-full object-contain animate-pulse"
        />
        {/* Anillo de carga sutil alrededor */}
        <div className="absolute inset-0 border-4 border-indigo-100 border-t-[#4F46E5] rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default Spinner;
